import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApplicationDocuments } from '../../models/application-menu/application-document';
import { IApplicationSubmissionResult } from '../../models/application-menu/application-submission-result';
import { ICalculatedFees } from '../../models/application-menu/calculated-fees';
import { environment } from '@env/environment';
import { IApplicationFeeModel } from 'app/models/reports/reports';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root',
})

export class SubmitApplicationService {
  private api: string = environment.privateApi + 'SubmitApplicationMenu/';
  private reportApi: string = environment.privateApi + 'Reports/';

  constructor(private http: HttpClient) {}

  getApplicationDocuments(appId: number): Observable<IApplicationDocuments[]> {
    return this.http.get<IApplicationDocuments[]>(this.api + 'getDocuments/' + appId, httpOptions);
  }

  uploadDocuments(files: FormData, appId: number): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'uploadDocuments/' + appId, files);
  }

  downloadDocument(fileId: number): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'downloadDocument/' + fileId, { responseType: 'blob' as 'json' });
  }

  deleteDocument(documentId: number): Observable<any> {
    return this.http.delete<any>(this.api + 'deleteDocument/' + documentId);
  }

  downloadCertificate(): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'downloadCertificate', { responseType: 'blob' as 'json' });
  }

  getApplicationReport(labId: number, appId: number): Observable<Blob> {
    return this.http.get<Blob>(this.reportApi + 'getApplicationReport/' + labId + '/' + appId, { responseType: 'blob' as 'json' });
  }

  calculateFees(appId: number, labId: number): Observable<ICalculatedFees> {
    return this.http.get<ICalculatedFees>(this.reportApi + 'calculateFees/' + appId + '/' + labId, httpOptions);
  }

  getApplicationFeeReport(appId: number): Observable<IApplicationFeeModel> {
    return this.http.get<IApplicationFeeModel>(this.reportApi + 'getApplicationFeeReport/' + appId, httpOptions);
  }

  submitApplication(labId: number): Observable<IApplicationSubmissionResult> {
    return this.http.get<IApplicationSubmissionResult>(this.api + 'submitApplication/' + labId, httpOptions);
  }
}
